import { shipmentPackagesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShipmentPackages";
import { shipmentPackagesCommonStyle } from "@store/theme/common/style/OrderShipmentPackages";

Object.assign(shipmentPackagesStyles, shipmentPackagesCommonStyle);
